"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const address_controller_1 = require("./address.controller");
const address_service_1 = require("./address.service");
const address_entity_1 = require("../../../../service-lib/src/lib/entities/address.entity");
const region_entity_1 = require("../../../../service-lib/src/lib/entities/region.entity");
const country_entity_1 = require("../../../../service-lib/src/lib/entities/country.entity");
const city_entity_1 = require("../../../../service-lib/src/lib/entities/city.entity");
const state_entity_1 = require("../../../../service-lib/src/lib/entities/state.entity");
const jwt_1 = require("@nestjs/jwt");
const address_repository_1 = require("./address.repository");
/**
 * Module for managing addresss.
 */
let AddressModule = class AddressModule {
};
exports.AddressModule = AddressModule;
exports.AddressModule = AddressModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([address_entity_1.Address, region_entity_1.Region, country_entity_1.Country, city_entity_1.City, state_entity_1.State]),
            jwt_1.JwtModule,
        ],
        controllers: [address_controller_1.AddressController],
        providers: [address_service_1.AddressService, address_repository_1.AddressRepository], // Add repositories
        exports: [address_service_1.AddressService], // Export AddressService so it can be used in other modules
    })
], AddressModule);
